import React from 'react';
import { ToastProvider } from './toast';
import { AuthProvider } from './auth';
import { CartProvider } from './cart';

const AppProvider: React.FC = ({ children }) => {
  return (
    <AuthProvider>
      <ToastProvider>
        <CartProvider>{children}</CartProvider>
      </ToastProvider>
    </AuthProvider>
  );
};

export default AppProvider;
